<template>
  <div class="scan-page">
    <div class="scan-container">
      <b-loading :active="isLoading" :is-full-page="false" />

      <b-field class="has-text-centered mb-5">
        <template #label>
          <span class="is-size-4 has-text-weight-bold">
            <b-icon icon="qrcode-scan" />
            Validação de Autorização
          </span>
        </template>
      </b-field>

      <b-card v-if="!autorizacao && !erro" class="mb-4">
        <b-card-header>
          <p class="card-header-title">
            <b-icon icon="camera" class="mr-2" />
            Escanear QR Code
          </p>
        </b-card-header>

        <b-card-content>
          <div id="reader" style="width: 300px; margin: auto"></div>

          <b-notification
            v-if="erroCamera"
            type="is-danger is-light"
            :closable="false"
            class="mt-3"
          >
            {{ erroCamera }}
          </b-notification>

          <b-notification
            v-else-if="!tokenLido"
            type="is-info is-light"
            :closable="false"
            class="mt-4 has-text-centered"
          >
            Aguardando leitura do QR Code...
          </b-notification>
        </b-card-content>

      </b-card>

      <b-card v-if="erro" class="result-card">
        <b-card-content class="has-text-centered">
          <b-icon
            icon="close-circle"
            type="is-danger"
            size="is-large"
            class="mb-3"
          />

          <p class="title is-5">Não foi possível validar a autorização</p>

          <b-tag type="is-danger" rounded class="mb-4"> NÃO AUTORIZADO </b-tag>

          <p class="has-text-danger mt-2">
            {{ erro }}
          </p>

          <b-button
            type="is-light"
            icon-left="qrcode-scan"
            expanded
            class="mt-4"
            @click="escanearNovamente"
          >
            Escanear novo QR Code
          </b-button>
        </b-card-content>
      </b-card>

      <b-card v-if="autorizacao" class="result-card">
        <b-card-content class="has-text-centered">
          <b-icon
            icon="check-decagram"
            type="is-success"
            size="is-large"
            class="mb-3"
          />

          <p class="title is-5">Autorização válida</p>

          <b-tag type="is-success" rounded class="mb-4"> AUTORIZADO </b-tag>

          <table class="table is-fullwidth mt-2">
            <tbody>
              <tr>
                <th>Solicitante</th>

                <td>
                  {{ autorizacao.nome || autorizacao.empresa }}
                </td>
              </tr>

              <tr>
                <th>Data de vencimento</th>

                <td>
                  {{ formatarDataHora(autorizacao.dataVencimento) }}
                </td>
              </tr>
            </tbody>
          </table>

          <b-button
            type="is-success"
            icon-left="login"
            expanded
            :loading="isRegistrandoEntrada"
            class="mt-4"
            @click="darEntrada"
          >
            Dar entrada
          </b-button>

          <div
            v-if="
              autorizacao.ultimosAcessos && autorizacao.ultimosAcessos.length
            "
            class="has-text-left mt-5"
          >
            <p class="has-text-weight-bold mb-2">
              <b-icon icon="history" size="is-small" class="mr-1" />

              Últimas entradas
            </p>

            <b-table
              :data="autorizacao.ultimosAcessos"
              narrowed
              hoverable
              :mobile-cards="false"
            >
              <b-table-column v-slot="e" label="Data/Hora" field="dataHora">
                {{ formatarDataHora(e.row.dataLeitura) }}
              </b-table-column>

              <b-table-column v-slot="e" label="Status" field="Status">
                {{ e.row.status || "N/A" }}
              </b-table-column>
            </b-table>
          </div>

          <div v-else class="has-text-grey mt-5">
            <b-icon icon="history" size="is-small" class="mr-1" />

            Nenhuma entrada registrada.
          </div>
          <b-button
            type="is-light"
            icon-left="qrcode-scan"
            expanded
            class="mt-4"
            @click="escanearNovamente"
          >
            Escanear novo QR Code
          </b-button>
        </b-card-content>
      </b-card>
    </div>
  </div>
</template>

<script>
import { Html5QrcodeScanner } from "html5-qrcode";
import DispositivosService from "@/services/DispositivosService";

export default {
  name: "ValidacaoQRCode",

  data() {
    return {
      scanner: null,
      tokenLido: null,
      autorizacao: null,
      isLoading: false,
      isRegistrandoEntrada: false,
      erro: null,
    };
  },

  computed: {
    ehCorporativo() {
      return this.autorizacao?.tipoAcessoDispositivo === "CORPORATIVO";
    },

    solicitanteLabel() {
      if (!this.autorizacao) return "";

      return this.ehCorporativo
        ? this.autorizacao.empresa
        : this.autorizacao.nome;
    },

    resultIcon() {
      return this.autorizacao ? "check-decagram" : "close-circle";
    },

    resultIconType() {
      return this.autorizacao ? "is-success" : "is-danger";
    },

    resultTitle() {
      return this.autorizacao ? "Autorização válida" : "Dispositivo bloqueado";
    },

    resultMessage() {
      return this.erro || "";
    },

    resultTagType() {
      return this.autorizacao ? "is-success" : "is-danger";
    },
  },

  mounted() {
    this.iniciarScanner();
  },

  methods: {
    iniciarScanner() {
      this.scanner = new Html5QrcodeScanner(
        "reader",
        { fps: 10, qrbox: 250 },
        false
      );

      this.scanner.render(
        (decodedText) => {
          // dispara tanto na leitura por câmera quanto na leitura de imagem importada
          this.tokenLido = decodedText;
          this.pararScanner();
          this.validarToken(decodedText);
        },
        () => {
          // erros de leitura de frame são normais, não exibir
        }
      );
    },

    pararScanner() {
      if (this.scanner) {
        this.scanner.clear().catch(() => {});
      }
    },

    async validarToken(token) {
      this.isLoading = true;
      this.erro = null;
      this.autorizacao = null;

      try {
        const response = await DispositivosService.validarQrCode(token);

        console.log("RESPOSTA DA VALIDAÇÃO:", response);
        console.log("STATUS HTTP:", response.status);
        console.log("DADOS:", response.data);

        // HTTP 200 = QR Code válido
        if (response.status === 200) {
          this.autorizacao = {
            ...response.data,
            valido: true,
          };

          return;
        }
      } catch (error) {
        console.error("ERRO AO VALIDAR QR CODE:", error);

        // Usa exatamente a mensagem enviada pelo backend
        this.erro =
          error.response?.data?.message ||
          "Não foi possível validar o QR Code.";
      } finally {
        this.isLoading = false;
      }
    },

    escanearNovamente() {
      this.tokenLido = null;
      this.autorizacao = null;
      this.erro = null;
      this.$nextTick(() => {
        this.iniciarScanner();
      });
    },
    async darEntrada() {
      console.log(">>> DAR ENTRADA FOI CLICADO <<<");
      if (!this.autorizacao?.acessoDispositivoId) {
        this.$buefy.toast.open({
          message: "Não foi possível identificar o dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });

        return;
      }

      this.isRegistrandoEntrada = true;

      try {
        const idAcessoDispositivo = this.autorizacao.acessoDispositivoId;

        console.log("REGISTRANDO ENTRADA");
        console.log("ID DO DISPOSITIVO:", idAcessoDispositivo);

        const response = await DispositivosService.registrarEntrada(
          idAcessoDispositivo
        );

        console.log("ENTRADA REGISTRADA:", response.data);

        this.$buefy.toast.open({
          message: "Entrada registrada com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });

        // Atualiza a lista de últimas entradas
        if (response.data?.ultimosAcessos) {
          this.autorizacao.ultimosAcessos = response.data.ultimosAcessos;
        }
      } catch (error) {
        console.error("ERRO AO REGISTRAR ENTRADA:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ||
            "Não foi possível registrar a entrada.",
          position: "is-bottom",
          type: "is-danger",
        });
      } finally {
        this.isRegistrandoEntrada = false;
      }
    },
    formatarDataHora(data) {
      if (!data) return "-";

      const [dataParte, horaParte] = data.split("T");

      if (!dataParte) return data;

      const [ano, mes, dia] = dataParte.split("-");

      if (!horaParte) {
        return `${dia}/${mes}/${ano}`;
      }

      const hora = horaParte.substring(0, 8);

      return `${dia}/${mes}/${ano} ${hora}`;
    },
  },
  beforeDestroy() {
    this.pararScanner();
  },
};
</script>

<style scoped>
.scan-page {
  padding: 32px 16px;
}
.scan-container {
  max-width: 460px;
  margin: 0 auto;
}
.result-card {
  border-top: 4px solid #dbdbdb;
}
</style>
